<template>
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-on="on" v-bind="attrs" @click="listAdhesions()">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </template>
    <v-card>
      <div id="print-report">
        <!-- Print Only -->
        <!-- <HeaderPrint /> -->
        <!-- Print Only -->
        <v-app-bar dense fixed>
          <div class="title text">{{ $t("promotion") }}: {{ title }}</div>
          <v-spacer></v-spacer>
          <v-btn class="mr-1" small icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container class="mt-8">
          <div v-if="noDataFound">
            <v-alert dense type="info" color="warning" class="mt-4">
              {{ errorMsg }}
            </v-alert>
          </div>
          <div>
            <v-card
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'margin: auto; margin-top: 24px;'
                  : 'width: 100%; margin: auto; margin-top: 24px;'
              "
            >
              <v-divider></v-divider>
              <div class="pa-2 d-print-none">
                <v-row no-gutters class="d-flex align-center">
                  <!-- <v-col cols="6" lg="9">
                      <v-btn
                        small
                        class="white black--text d-print-none"
                        @click="$printReport()"
                      >
                        <v-icon small left>mdi-printer</v-icon>
                        {{ $t("print") }}
                      </v-btn>
                    </v-col> -->
                  <div class="d-flex flex-column subtitle-2">
                    <div class="orange--text">
                      {{ $t("bonusTotalConcedido") }}
                      {{ givenBonus }}
                    </div>
                    <div class="red--text">
                      {{ $t("bonusTotalResgatado") }}
                      {{ bonus_total_resgatado }}
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-col
                    cols="12"
                    lg="3"
                    md="4"
                    :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      :label="$t('search')"
                      single-line
                      hide-details
                      dense
                      solo-inverted
                      clearable
                    ></v-text-field>
                  </v-col>
                  <div style="width: 100%;">
                    <GroupExport class="my-3" />
                    <div class="d-flex justify-end">
                      <v-btn
                        class="info"
                        small
                        :disabled="loading"
                        @click="exportListAdhesions()"
                      >
                        <v-icon small left>mdi-file-export</v-icon>
                        {{ $t("exportAdhesions") }}
                      </v-btn>
                    </div>
                  </div>
                </v-row>
              </div>
              <v-divider></v-divider>
              <!-- main datatable -->
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                item-key="id_usuario"
                :single-expand="true"
                :loading="loading"
                show-expand
                :expanded.sync="expanded"
              >
                <template v-slot:item.id_promo="{ item }">
                  <v-btn @click="$copy(item.id_promo)" x-small>{{
                    item.id_promo
                  }}</v-btn>
                </template>
                <template v-slot:item.nome="{ item }">
                  <div class="d-flex align-center">
                    <div class="mr-1">
                      <span>{{ item.nome }}</span>
                    </div>
                    <div>
                      <v-icon
                        x-small
                        :color="colorStatusUser(item.usuarios_status)"
                      >
                        mdi-circle
                      </v-icon>
                    </div>
                  </div>
                </template>

                <template v-slot:item.valor_bonus="{ item }">
                  <div class="d-flex align-center">
                    <div class="mr-1">
                      {{ $t("labelCurrency") }}
                    </div>
                    <div>
                      {{ item.valor_bonus }}
                    </div>
                  </div>
                </template>

                <template v-slot:item.id_usuario="{ item }">
                  <v-btn @click="$copy(item.id_usuario)" x-small>{{
                    item.id_usuario
                  }}</v-btn>
                </template>

                <template v-slot:item.data_ativacao="{ item }">
                  <div class="caption">
                    {{ item.data_ativacao }}
                  </div>
                </template>
                <template v-slot:item.usuario_promos_status="{ item }">
                  <v-chip
                    :color="statusColor(item.usuario_promos_status)"
                    small
                    class="caption"
                  >
                    {{ userPromosStatusUI(item.usuario_promos_status) }}
                  </v-chip>
                </template>

                <template v-slot:item.rollover_atual="{ item }">
                  <div class="d-flex align-center">
                    <div class="mr-1">
                      {{ $t("labelCurrency") }}
                    </div>
                    <div>
                      {{ item.rollover_atual }}
                    </div>
                  </div>
                </template>

                <template v-slot:item.rollover_total="{ item }">
                  <div class="d-flex align-center">
                    <div class="mr-1">
                      {{ $t("labelCurrency") }}
                    </div>
                    <div>
                      <span class="caption">
                        {{ item.rollover_total }}
                      </span>
                    </div>
                  </div>
                </template>
                <!-- ================== -->
                <!-- EXTRATO DE ADESÕES -->
                <!-- ================== -->

                <!-- HEADER EXTRATO -->
                <template v-slot:header.data-table-expand="{ header }">
                  <div class="d-flex align-center">
                    <div>
                      <span>
                        {{ header.text }}
                      </span>
                    </div>
                    <div>
                      <th>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              icon
                              v-bind="attrs"
                              v-on="on"
                              class="d-print-none"
                            >
                              <v-icon small color="info">
                                mdi-information-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("userExtract") }}</span>
                        </v-tooltip>
                      </th>
                    </div>
                  </div>
                </template>
                <!-- ITEM EXTRATO BTN -->
                <template
                  v-slot:item.data-table-expand="{ item, isExpanded, expand }"
                >
                  <v-btn
                    @click="[expand(true), getExtractAdhesion(item.id_usuario)]"
                    v-if="!isExpanded"
                    class="info"
                    light
                    small
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    @click="expand(false)"
                    v-if="isExpanded"
                    class="white"
                    light
                    small
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <template v-slot:expanded-item="{ headers }">
                  <td :colspan="headers.length" class="pa-4 grey lighten-2">
                    <div
                      v-if="extractItems == [] && errorMsg == null"
                      class="d-flex justify-center"
                    >
                      <div class="my-6">
                        <v-progress-circular
                          :size="70"
                          :width="7"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </div>
                    <div
                      v-else-if="extractItems == [] && errorMsg"
                      class="text-center black--text"
                    >
                      <h3>{{ errorMsg }}</h3>
                    </div>
                    <div v-else>
                      <!-- datatable extrato -->
                      <div class=" mb-3">
                        <span class="title black--text">{{
                          $t("adhesionExtract")
                        }}</span>
                      </div>
                      <v-data-table
                        :headers="extractHeaders"
                        :items="extractItems"
                      >
                        <template v-slot:item.id="{ item }">
                          <v-btn @click="$copy(item.id)" x-small>{{
                            item.id
                          }}</v-btn>
                        </template>
                        <template v-slot:item.data_lancamento="{ item }">
                          <span class="caption">
                            {{ item.data_lancamento }}
                          </span>
                        </template>
                        <template v-slot:item.valor="{ item }">
                          <div class="d-flex align-center">
                            <div class="mr-1">
                              {{ $t("labelCurrency") }}
                            </div>
                            <div>
                              {{ item.valor }}
                            </div>
                          </div>
                        </template>
                        <template v-slot:item.saldo_anterior="{ item }">
                          <div class="d-flex align-center">
                            <div class="mr-1">
                              {{ $t("labelCurrency") }}
                            </div>
                            <div>
                              {{ item.saldo_anterior }}
                            </div>
                          </div>
                        </template>
                        <template v-slot:item.saldo_posterior="{ item }">
                          <div class="d-flex align-center">
                            <div class="mr-1">
                              {{ $t("labelCurrency") }}
                            </div>
                            <div>
                              {{ item.saldo_posterior }}
                            </div>
                          </div>
                        </template>
                      </v-data-table>
                    </div>
                  </td>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        @click="exportTransfers(item.id_usuario)"
                      >
                        <v-icon>mdi-file-export</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("exportTransfers") }}</span>
                  </v-tooltip>
                </template>
                <!-- // Buttons OPEN and CLOSE TD -->
              </v-data-table>
            </v-card>
          </div>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// import HeaderPrint from "@/components/common/header-print";
import GroupExport from "@/components/common/filters/GroupExport.vue";

export default {
  name: "listAdhesions",
  props: [
    "id_promo",
    "title",
    "bonus_total_concedido",
    "bonus_total_resgatado",
  ],
  components: {
    // HeaderPrint,
    GroupExport,
  },
  data: () => ({
    loading: false,
    dialog: false,
    awaitingData: false,
    itemsFound: false,
    errorMsg: null,
    items: [],
    idUser: "",
    search: "",
    // expand
    extractItems: [],
    expanded: [],
    noDataFound: false,
    givenBonus: 0,
  }),
  computed: {
    headers() {
      return [
        // {
        //   text: this.$t('idPromotion'),
        //   value: "id_promo",
        //   align: 'caption'
        // },
        {
          text: this.$t("idUser"),
          value: "id_usuario",
          align: "caption",
        },
        {
          text: this.$t("name"),
          value: "nome",
          align: "caption",
        },
        {
          text: this.$t("bonus"),
          value: "valor_bonus",
          align: "caption",
        },
        {
          text: this.$t("activation"),
          value: "data_ativacao",
          align: "caption",
        },
        {
          text: this.$t("expiration"),
          value: "data_expiracao",
          align: "caption",
        },
        {
          text: "Status",
          value: "usuario_promos_status",
          align: "caption",
        },
        {
          text: this.$t("currentRollover"),
          value: "rollover_atual",
          align: "caption",
        },
        {
          text: this.$t("totalRollover"),
          value: "rollover_total",
          align: "caption",
        },
        {
          text: this.$t("extract"),
          value: "data-table-expand",
          align: "caption",
        },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
    extractHeaders() {
      return [
        {
          text: "ID",
          value: "id",
        },
        {
          text: this.$t("nameOperation"),
          value: "nome_operacao",
        },
        {
          text: this.$t("entryDate"),
          value: "data_lancamento",
        },
        {
          text: this.$t("value"),
          value: "valor",
        },
        {
          text: this.$t("previousBalance"),
          value: "saldo_anterior",
        },
        {
          text: this.$t("subsequentBalance"),
          value: "saldo_posterior",
        },
      ];
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },
  // watch:{
  //   $router(){
  //     console.log(this.$router.name)
  //   }
  // },
  methods: {
    listAdhesions() {
      this.loading = true;
      this.noDataFound = false;
      this.errorMsg = null;
      this.$router
        .push({
          name: "ListAdhesions",
          query: { id_promo: this.id_promo, code_promo: this.code_promo },
        })
        .catch(() => {});
      const body = {
        id_promo: this.id_promo,
        // id_promo: 1,
      };
      this.$axios
        .post(
          "/administrator/promotions/listPromotionsAdhesions",
          this.$formdata(body)
        )
        .then((response) => {
          this.items = response.data.dados;
          this.items.forEach((item) => {
            item.data_cadastro = this.formatDate(item.data_cadastro);
            item.data_ativacao = this.formatDate(
              item.data_ativacao.replace(" ", "T").toLocaleString()
            );
            item.data_expiracao = this.formatDate(
              item.data_expiracao.replace(" ", "T").toLocaleString()
            );
          });

          const givenBonus = this.items.reduce(
            (n, { valor_bonus }) => n + Number(valor_bonus),
            0
          );

          this.givenBonus = givenBonus.toFixed(2);
        })
        .catch((error) => {
          console.log(error);
          this.errorMsg = error.response.data.messages.error;
          this.noDataFound = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async exportListAdhesions() {
      this.loading = true;
      const extension = this.exportDoc;

      await this.$request.exportDoc(
        "/administrator/promotions/listPromotionsAdhesions",
        {
          id_promo: this.id_promo,
          export: extension,
        },
        extension
      );

      this.loading = false;
    },
    async exportTransfers(id_user) {
      this.loading = true;
      const extension = this.exportDoc;

      await this.$request.exportDoc(
        "/administrator/promotions/listEntrysByUserPromos",
        {
          id_promo: this.id_promo,
          id_user,
          export: extension,
        },
        extension
      );

      this.loading = false;
    },
    getExtractAdhesion(id_user) {
      this.extractItems = "";
      this.errorMsg = null;
      const body = {
        id_promo: this.id_promo,
        id_user: id_user,
      };
      this.$axios
        .post(
          "/administrator/promotions/listEntrysByUserPromos",
          this.$formdata(body)
        )
        .then((response) => {
          this.extractItems = response.data.dados;
          this.extractItems.forEach((item) => {
            item.data_lancamento = new Date(
              item.data_lancamento.replace(" ", "T")
            ).toLocaleString();
            if (item.id_operacao == 10 || item.id_operacao == 16) {
              console.log(item.nome_operacao);
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errorMsg = error.response.data.messages.error;
        });
    },
    userPromosStatusUI(value) {
      const obj = {
        // 0 - Inativo
        // 1 - Ativo
        // 2 - finalizado
        // 3 - Cancelado
        // 4 - Expirado
        0: this.$t("inactivePromo"),
        1: this.$t("activePromo"),
        2: this.$t("finalizedPromo"),
        3: this.$t("cancelledPromo"),
        4: this.$t("expiredPromo"),
      };
      return obj[value];
    },
    statusColor(value) {
      if (value == 0) return "grey"; // inativo
      if (value == 1) return "green"; // ativo
      if (value == 2) return "black"; // finalizado
      if (value == 3) return "purple darken-4"; // cancelado
      if (value == 4) return "warning"; // expirado
    },
    colorStatusUser(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },
    closeDialog() {
      this.$router.go(-1);
      this.expanded = [];
      this.noDataFound = false;
      (this.errorMsg = null), (this.dialog = false);
    },
    formatDate(fullDate) {
      if (fullDate) {
        const lang =
          localStorage.getItem("language") ||
          this.$store.state.language ||
          "pt";
        return new Date(fullDate).toLocaleString(lang);
      }
      return;
    },
  },
};
</script>
<style>
.text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
